import React, { useState, useEffect } from "react";
let left;
let right;

const Timer = ({ startingtime, currenttime, creategam, gettimefast,setdisable, resulthistoryfast }) => {
  const [time, setTime] = useState(null);

  useEffect(() => {
    if (time === 0) {
      creategam();
       
      setTimeout(() => {
        gettimefast();
        resulthistoryfast(); 
        setdisable(false)
      }, 500);
    }
    if(time<=5)
    {
     
      setdisable(true)
    }
  
  }, [time]);

  useEffect(() => {
    if (!startingtime || !currenttime) return;

    const start = parseInt(startingtime);
    const curr = parseInt(currenttime);
    const Time = 30 - (curr - start);
    if (Time >= 30) {
      creategam();
      setTimeout(() => {
        gettimefast();
        setdisable(false)
        resulthistoryfast(); 
      }, 500);
    }
    if (Time < 0) {
      creategam();
      setTimeout(() => {
        gettimefast();
        setdisable(false)
        resulthistoryfast(); 
      }, 500);
    }
    if (Time === 0) {
      creategam();
      setTimeout(() => {
        gettimefast();
        setdisable(false)
        resulthistoryfast(); 
      }, 500);
    }
    
    setTime(Time);
  
    const interval = setInterval(() => {
      setTime((time) => (time > 0 ? time - 1 : time));
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [startingtime, currenttime]);

  const min = Math.floor((time ?? 0) / 60);
  const sec = (time ?? 0) - min * 60;

  return (
    <>
      <p className="countset">
        <span className="coutdown">{min ? Math.floor(min / 10) : "0"}</span>
        <span className="coutdown">{min ? min : "0"}</span>:
        <span className="coutdown">{sec ? Math.floor(sec / 10) : "0"}</span>
        <span className="coutdown">{sec ? sec % 10 : "0"}</span>
      </p>
    </>
  );
};

export default Timer;
